import { type StateCreator } from 'zustand';

import { type Annotation } from '@air/api/types';

/**
 * Upper bound on undo/redo steps retained by the zundo `temporal` middleware.
 * Wired into the store's `temporal({ limit })` config in `AnnotationV2Provider`.
 */
export const MAX_ANNOTATION_HISTORY_SIZE = 50;

export type AnnotationHistorySlice = {
  annotations: Annotation[];
  /**
   * Clears the present annotations. Undo/redo history is owned by the zundo
   * `temporal` store and is cleared separately via `store.temporal.getState().clear()`.
   */
  resetAnnotationHistory: () => void;
  setAnnotations: (annotations: Annotation[]) => void;
};

export type AnnotationHistorySliceInitialState = Pick<AnnotationHistorySlice, 'annotations'>;

export const INITIAL_ANNOTATION_HISTORY_STATE: AnnotationHistorySlice['annotations'] = [];

export type CreateAnnotationHistorySlice = (
  initialState?: Partial<AnnotationHistorySliceInitialState>,
) => StateCreator<AnnotationHistorySlice, [], [], AnnotationHistorySlice>;

export const createAnnotationHistorySlice: CreateAnnotationHistorySlice = (initialState) => (set) => ({
  annotations: initialState?.annotations ?? INITIAL_ANNOTATION_HISTORY_STATE,
  resetAnnotationHistory: () => set({ annotations: [] }),
  setAnnotations: (annotations) => set({ annotations }),
});
